// TelcoTrack — Věcná břemena: větve, osy stavu, typy nástrojů, CETIN šablony

export const BREMENA_BRANCHES = ['smluvni_sluzebnost', 'suz_umisteni', 'zakonna_104a'] as const;
export type BremenaBranch = (typeof BREMENA_BRANCHES)[number];

export const BREMENA_BRANCH_LABELS_CS: Record<BremenaBranch, string> = {
  smluvni_sluzebnost: 'Smluvní služebnost',
  suz_umisteni: 'Smlouva o umístění (SÚZ)',
  zakonna_104a: 'Zákonné břemeno (§ 104a)',
};

export const BREMENA_CASE_WORK_STATUSES = [
  'novy',
  'kontrola_vstupu',
  'priprava',
  'kontrola',
  'jednani',
  'cekani',
  'vyporadavani',
  'predani',
  'uzavreny',
  'blokace',
  'vratit_doplneni',
  'zruseny',
] as const;
export type BremenaCaseWorkStatus = (typeof BREMENA_CASE_WORK_STATUSES)[number];

export const BREMENA_CASE_WORK_STATUS_LABELS_CS: Record<BremenaCaseWorkStatus, string> = {
  novy: 'Nový',
  kontrola_vstupu: 'Kontrola vstupu',
  priprava: 'Příprava',
  kontrola: 'Kontrola',
  jednani: 'Jednání',
  cekani: 'Čekání',
  vyporadavani: 'Vypořádávání',
  predani: 'Předání',
  uzavreny: 'Uzavřený',
  blokace: 'Blokace',
  vratit_doplneni: 'Vrátit k doplnění',
  zruseny: 'Zrušený',
};

export const BREMENA_DOCUMENT_AXIS_STATUSES = [
  'koncept',
  'ke_kontrole',
  'schvalen_k_podpisu',
  'castecne_podepsan',
  'podpisy_kompletni',
  'ucinny',
  'odmitnuty',
  'nahrazeny',
  'zanikly',
] as const;
export type BremenaDocumentAxisStatus = (typeof BREMENA_DOCUMENT_AXIS_STATUSES)[number];

export const BREMENA_DOCUMENT_AXIS_STATUS_LABELS_CS: Record<BremenaDocumentAxisStatus, string> = {
  koncept: 'Koncept',
  ke_kontrole: 'Ke kontrole',
  schvalen_k_podpisu: 'Schválen k podpisu',
  castecne_podepsan: 'Částečně podepsán',
  podpisy_kompletni: 'Podpisy kompletní',
  ucinny: 'Účinný',
  odmitnuty: 'Odmítnutý',
  nahrazeny: 'Nahrazený',
  zanikly: 'Zaniklý',
};

export const BREMENA_KATASTR_AXIS_STATUSES = [
  'nevyžaduje_se',
  'pripravuje_se',
  'podano',
  'vyzva_doplneni',
  'preruseno',
  'provedeno',
  'zamitnuto',
  'zastaveno',
  'vymaz',
] as const;
export type BremenaKatastrAxisStatus = (typeof BREMENA_KATASTR_AXIS_STATUSES)[number];

export const BREMENA_KATASTR_AXIS_STATUS_LABELS_CS: Record<BremenaKatastrAxisStatus, string> = {
  nevyžaduje_se: 'Nevyžaduje se',
  pripravuje_se: 'Připravuje se',
  podano: 'Podáno',
  vyzva_doplneni: 'Výzva k doplnění',
  preruseno: 'Přerušeno',
  provedeno: 'Provedeno',
  zamitnuto: 'Zamítnuto',
  zastaveno: 'Zastaveno',
  vymaz: 'Výmaz',
};

export const BREMENA_FINANCE_AXIS_STATUSES = [
  'neurceno',
  'nabidnuto',
  'schvaleno',
  'zavazek',
  'vyuctovano',
  'splatne',
  'uhrazeno',
  'spor',
] as const;
export type BremenaFinanceAxisStatus = (typeof BREMENA_FINANCE_AXIS_STATUSES)[number];

export const BREMENA_FINANCE_AXIS_STATUS_LABELS_CS: Record<BremenaFinanceAxisStatus, string> = {
  neurceno: 'Neurčeno',
  nabidnuto: 'Nabídnuto',
  schvaleno: 'Schváleno',
  zavazek: 'Závazek',
  vyuctovano: 'Vyúčtováno',
  splatne: 'Splatné',
  uhrazeno: 'Uhrazeno',
  spor: 'Spor',
};

export const BREMENA_READINESS_AXIS_STATUSES = [
  'nedostatek_podkladu',
  'chybi_titul',
  'ceka_na_podminku',
  'pripraveno',
  'vyzaduje_overeni',
] as const;
export type BremenaReadinessAxisStatus = (typeof BREMENA_READINESS_AXIS_STATUSES)[number];

export const BREMENA_READINESS_AXIS_STATUS_LABELS_CS: Record<BremenaReadinessAxisStatus, string> = {
  nedostatek_podkladu: 'Nedostatek podkladů',
  chybi_titul: 'Chybí titul',
  ceka_na_podminku: 'Čeká na podmínku',
  pripraveno: 'Připraveno',
  vyzaduje_overeni: 'Vyžaduje ověření',
};

export const BREMENA_INSTRUMENT_TYPES = [
  'sosb',
  'sk_konecna',
  'zrizeni_sluzebnosti',
  'suz',
  'souhlas',
  'zakonny_104a',
  'existujici_pravo',
] as const;
export type BremenaInstrumentType = (typeof BREMENA_INSTRUMENT_TYPES)[number];

export const BREMENA_INSTRUMENT_TYPE_LABELS_CS: Record<BremenaInstrumentType, string> = {
  sosb: 'Smlouva o smlouvě budoucí',
  sk_konecna: 'Smlouva konečná',
  zrizeni_sluzebnosti: 'Smlouva o zřízení služebnosti',
  suz: 'Smlouva o umístění zařízení',
  souhlas: 'Souhlas',
  zakonny_104a: 'Zákonné břemeno',
  existujici_pravo: 'Existující právo',
};

/**
 * Hub „Břemena“ matrix columns (signed / generated per polygon).
 * Order matches product: budoucí → konečná → zřízení → SÚZ → §104a.
 */
export const BREMENA_HUB_CONTRACT_TYPES = [
  'sosb',
  'sk_konecna',
  'zrizeni_sluzebnosti',
  'suz',
  'zakonny_104a',
] as const satisfies readonly BremenaInstrumentType[];

export type BremenaHubContractType = (typeof BREMENA_HUB_CONTRACT_TYPES)[number];

/** Short column headers for the hub table. */
export const BREMENA_HUB_CONTRACT_COLUMN_LABELS_CS: Record<BremenaHubContractType, string> = {
  sosb: 'Budoucí',
  sk_konecna: 'Konečná',
  zrizeni_sluzebnosti: 'Zřízení',
  suz: 'SÚZ',
  zakonny_104a: '§104a',
};

/** ISKN / n8n CHAROS kódy subjektů používané ve věcných břemenech.
 * 20 = právnická osoba (PO) — v n8n/šablonách „povinný subjekt“ ze smlouvy VBŘ. */
export const BREMENA_CHAROS_KOD_CODES = {
  '1': 'sjm',
  '2': 'fo',
  '3': 'stat',
  '4': 'obec',
  '5': 'kraj',
  '6': 'svj',
  '12': 'bd',
  '20': 'povinny_subjekt',
  '72': 'cirkev',
} as const;

export type BremenaCharOsKod = keyof typeof BREMENA_CHAROS_KOD_CODES;
export type BremenaCharOsKodKind = (typeof BREMENA_CHAROS_KOD_CODES)[BremenaCharOsKod];

export const BREMENA_CHAROS_KOD_LABELS_CS: Record<BremenaCharOsKod, string> = {
  '1': 'SJM',
  '2': 'FO',
  '3': 'Stát',
  '4': 'Obec',
  '5': 'Kraj',
  '6': 'SVJ',
  '12': 'BD',
  /** n8n / VBŘ „povinný subjekt“ = obchodní společnost / právnická osoba. */
  '20': 'Právnická osoba',
  '72': 'Církev',
};

/** Display order for CharOs select (FO + PO together; not raw Object.keys numeric order). */
export const BREMENA_CHAROS_KOD_ORDER: readonly BremenaCharOsKod[] = [
  '1',
  '2',
  '20',
  '3',
  '4',
  '5',
  '6',
  '12',
  '72',
] as const;

/** Placeholdery v CETIN HTML šablonách věcných břemen. */
export const BREMENA_TEMPLATE_PLACEHOLDERS = [
  'Cislo_SAP',
  'KIA_kod',
  'Cislo_smlouvy',
  'Oznaceni_stavby',
  'Sirka_VB',
  'Popis_zarizeni',
  'Hlavicka_Vlastnik',
  'Odstavec_Specifikace_Pozemku',
  'Odstavec_DPH',
  'Odstavec_Trvani',
  'Odstavec_Nahrada',
  'Odstavec_Platba',
  'Odstavec_Zaverecna_Komplet',
  'Podpisy_Vlastniku',
  'Datum',
  'Slovo_Pozemek',
  'Slovo_Pozemku_Do',
  'Slovo_Pozemku_K',
  'Slovo_Pozemku_Na',
  'Slovo_Pozemek_Do',
  'Slovo_Pozemek_K',
  'Slovo_Jeho_K',
] as const;
export type BremenaTemplatePlaceholder = (typeof BREMENA_TEMPLATE_PLACEHOLDERS)[number];

/**
 * Stav smlouvy / dokumentu (1 nástroj = 1 stav).
 * Vygenerovaná = PDF s mezerami; Upravená = Drive edit (ještě nekompletní);
 * Kompletní = všechny povinné fill hodnoty; Odeslaná = ISDS/pošta;
 * Podepsaná = ručně nebo AI/heuristika na odpovědi.
 *
 * Legacy `nekompletni` mapuje → `vygenerovana`. Migrace 196 kdysi přemapovala
 * staré `kompletni` → `vygenerovana`; nové `kompletni` je opět first-class.
 */
export const BREMENA_CONTRACT_STATUSES = [
  'vygenerovana',
  'upravena',
  'kompletni',
  'odeslana',
  'podepsana',
] as const;
export type BremenaContractStatus = (typeof BREMENA_CONTRACT_STATUSES)[number];

export const BREMENA_CONTRACT_STATUS_LABELS_CS: Record<BremenaContractStatus, string> = {
  vygenerovana: 'Vygenerovaná',
  upravena: 'Upravená',
  kompletni: 'Kompletní',
  odeslana: 'Odeslaná',
  podepsana: 'Podepsaná',
};

/** Older instrument.status values still present in DB / WIP payloads. */
const BREMENA_CONTRACT_STATUS_LEGACY: Record<string, BremenaContractStatus> = {
  nekompletni: 'vygenerovana',
  ready: 'vygenerovana',
  ke_kontrole: 'vygenerovana',
  edited: 'upravena',
  sent: 'odeslana',
  odeslano: 'odeslana',
  signed: 'podepsana',
  podepsano: 'podepsana',
  hotovo: 'podepsana',
  done: 'podepsana',
  effective: 'podepsana',
  ucinny: 'podepsana',
};

export const BREMENA_TEMPLATE_CATALOG_STATUSES = ['ceka_na_potvrzeni', 'aktivni', 'archiv'] as const;
export type BremenaTemplateCatalogStatus = (typeof BREMENA_TEMPLATE_CATALOG_STATUSES)[number];

export const BREMENA_TEMPLATE_CATALOG_STATUS_LABELS_CS: Record<BremenaTemplateCatalogStatus, string> = {
  ceka_na_potvrzeni: 'Čeká na potvrzení',
  aktivni: 'Aktivní',
  archiv: 'Archiv',
};

function includesConst<T extends string>(values: readonly T[], value: string | null | undefined): value is T {
  return (values as readonly string[]).includes((value ?? '').trim());
}

function normalizeConst<T extends string>(
  values: readonly T[],
  value: string | null | undefined,
): T | null {
  const key = (value ?? '').trim();
  if (!key) return null;
  return includesConst(values, key) ? key : null;
}

export function isBremenaBranch(value: string | null | undefined): value is BremenaBranch {
  return includesConst(BREMENA_BRANCHES, value);
}

export function normalizeBremenaBranch(value: string | null | undefined): BremenaBranch | null {
  return normalizeConst(BREMENA_BRANCHES, value);
}

export function isBremenaCaseWorkStatus(value: string | null | undefined): value is BremenaCaseWorkStatus {
  return includesConst(BREMENA_CASE_WORK_STATUSES, value);
}

export function normalizeBremenaCaseWorkStatus(
  value: string | null | undefined,
): BremenaCaseWorkStatus | null {
  return normalizeConst(BREMENA_CASE_WORK_STATUSES, value);
}

export function isBremenaDocumentAxisStatus(
  value: string | null | undefined,
): value is BremenaDocumentAxisStatus {
  return includesConst(BREMENA_DOCUMENT_AXIS_STATUSES, value);
}

export function normalizeBremenaDocumentAxisStatus(
  value: string | null | undefined,
): BremenaDocumentAxisStatus | null {
  return normalizeConst(BREMENA_DOCUMENT_AXIS_STATUSES, value);
}

export function isBremenaKatastrAxisStatus(
  value: string | null | undefined,
): value is BremenaKatastrAxisStatus {
  return includesConst(BREMENA_KATASTR_AXIS_STATUSES, value);
}

export function normalizeBremenaKatastrAxisStatus(
  value: string | null | undefined,
): BremenaKatastrAxisStatus | null {
  return normalizeConst(BREMENA_KATASTR_AXIS_STATUSES, value);
}

export function isBremenaFinanceAxisStatus(
  value: string | null | undefined,
): value is BremenaFinanceAxisStatus {
  return includesConst(BREMENA_FINANCE_AXIS_STATUSES, value);
}

export function normalizeBremenaFinanceAxisStatus(
  value: string | null | undefined,
): BremenaFinanceAxisStatus | null {
  return normalizeConst(BREMENA_FINANCE_AXIS_STATUSES, value);
}

export function isBremenaReadinessAxisStatus(
  value: string | null | undefined,
): value is BremenaReadinessAxisStatus {
  return includesConst(BREMENA_READINESS_AXIS_STATUSES, value);
}

export function normalizeBremenaReadinessAxisStatus(
  value: string | null | undefined,
): BremenaReadinessAxisStatus | null {
  return normalizeConst(BREMENA_READINESS_AXIS_STATUSES, value);
}

export function isBremenaInstrumentType(value: string | null | undefined): value is BremenaInstrumentType {
  return includesConst(BREMENA_INSTRUMENT_TYPES, value);
}

export function normalizeBremenaInstrumentType(
  value: string | null | undefined,
): BremenaInstrumentType | null {
  return normalizeConst(BREMENA_INSTRUMENT_TYPES, value);
}

export function isBremenaCharOsKod(value: string | null | undefined): value is BremenaCharOsKod {
  const key = (value ?? '').trim();
  return key in BREMENA_CHAROS_KOD_CODES;
}

export function normalizeBremenaCharOsKod(value: string | null | undefined): BremenaCharOsKod | null {
  const key = (value ?? '').trim();
  return isBremenaCharOsKod(key) ? key : null;
}

/**
 * Derive `bremena_subjects.subject_kind` from CharOsKod (canonical KN field).
 * Parity with import `mapSubjectKind` when kod is present:
 * 1/2 → fo, 20/72 → po, 3 → stat, 4 → obec, 5 → kraj, 6 → svj, else jine.
 * Returns null when CharOs is empty (caller should leave subject_kind unchanged).
 */
export function bremenaSubjectKindFromCharOsKod(
  charOsKod: string | null | undefined,
): string | null {
  const kod = (charOsKod ?? '').trim();
  if (!kod) return null;
  switch (kod) {
    case '5':
      return 'kraj';
    case '4':
      return 'obec';
    case '3':
      return 'stat';
    case '6':
      return 'svj';
    case '1':
    case '2':
      return 'fo';
    case '20':
    case '72':
      return 'po';
    default:
      return 'jine';
  }
}

export function isBremenaTemplatePlaceholder(
  value: string | null | undefined,
): value is BremenaTemplatePlaceholder {
  return includesConst(BREMENA_TEMPLATE_PLACEHOLDERS, value);
}

export function isBremenaTemplateCatalogStatus(
  value: string | null | undefined,
): value is BremenaTemplateCatalogStatus {
  return includesConst(BREMENA_TEMPLATE_CATALOG_STATUSES, value);
}

export function normalizeBremenaTemplateCatalogStatus(
  value: string | null | undefined,
): BremenaTemplateCatalogStatus | null {
  return normalizeConst(BREMENA_TEMPLATE_CATALOG_STATUSES, value);
}

export function isBremenaContractStatus(
  value: string | null | undefined,
): value is BremenaContractStatus {
  return includesConst(BREMENA_CONTRACT_STATUSES, value);
}

export function normalizeBremenaContractStatus(
  value: string | null | undefined,
): BremenaContractStatus | null {
  const key = (value ?? '').trim().toLowerCase();
  if (!key) return null;
  if (includesConst(BREMENA_CONTRACT_STATUSES, key)) return key;
  return BREMENA_CONTRACT_STATUS_LEGACY[key] ?? null;
}

/**
 * CharOsKod *hint* for recommended § 104a (stát / obec / kraj).
 * Not legal proof — parcel/ownership evaluator decides coverage.
 * Not `20` (povinný subjekt / městská s.r.o.) — that must not get §104a (A07).
 */
export const BREMENA_CHAROS_KOD_104A_ELIGIBLE = ['3', '4', '5'] as const;

export type BremenaPrivateContractPhase = 'pre_construction' | 'post_survey';

/**
 * Recommendation codes stored on settlement units / import proposals.
 * CharOs 3/4/5 → `DOPORUCENO_104A` (authorized person confirms later).
 */
export const BREMENA_LEGAL_PATH_RECOMMENDATION_CODES = [
  'DOPORUCENO_SOSB',
  'DOPORUCENO_104A',
  'DOPORUCENO_SUZ',
  'K_POSOUZENI_EXPERT',
  'NEURCENO',
] as const;
export type BremenaLegalPathRecommendationCode =
  (typeof BREMENA_LEGAL_PATH_RECOMMENDATION_CODES)[number];

export const BREMENA_LEGAL_PATH_RECOMMENDATION_LABELS_CS: Record<
  BremenaLegalPathRecommendationCode,
  string
> = {
  DOPORUCENO_SOSB: 'Doporučeno: smluvní služebnost (SoSB)',
  DOPORUCENO_104A: 'Doporučeno: zákonné břemeno (§ 104a)',
  DOPORUCENO_SUZ: 'Doporučeno: SÚZ',
  K_POSOUZENI_EXPERT: 'K posouzení expertem (neslučitelné nemovitosti / smíšené vlastnictví)',
  NEURCENO: 'Právní větev neurčena',
};

/** Suggested / confirmed legal branch on a settlement unit (owner circle). */
export type BremenaSuggestedLegalPath = Extract<
  BremenaBranch,
  'smluvni_sluzebnost' | 'zakonna_104a' | 'suz_umisteni'
>;

export interface BremenaLegalPathSuggestion {
  /** Branch to propose — never auto-confirmed on import. */
  suggestedLegalPath: BremenaSuggestedLegalPath | null;
  recommendationCode: BremenaLegalPathRecommendationCode;
  /** Instrument type hint for UI (same mapping as legacy suggestBremenaInstrumentType). */
  suggestedInstrumentType: Extract<
    BremenaInstrumentType,
    'zakonny_104a' | 'sosb' | 'sk_konecna'
  > | null;
  /**
   * CharOs-only hint (ELIGIBLE | NOT_ELIGIBLE | NEEDS_REVIEW).
   * Not legal proof of §104a — use parcel/ownership evaluator for coverage.
   */
  section104aEligibility: 'ELIGIBLE' | 'NOT_ELIGIBLE' | 'NEEDS_REVIEW';
}

/**
 * Propose legal path for one owner/subject from CharOsKod **hint**.
 * CharOs 3/4/5 → `DOPORUCENO_104A` (ELIGIBLE hint, not proof).
 * CharOs 20 → SoSB / NOT_ELIGIBLE (never §104a).
 * Coverage for a circle/parcel must use `proposeLegalPathForOwnerCircle`.
 */
export function suggestBremenaLegalPath(
  charOsKod: string | null | undefined,
  phase: BremenaPrivateContractPhase = 'pre_construction',
): BremenaLegalPathSuggestion {
  const kod = (charOsKod ?? '').trim();
  if (!kod) {
    return {
      suggestedLegalPath: null,
      recommendationCode: 'NEURCENO',
      suggestedInstrumentType: null,
      section104aEligibility: 'NEEDS_REVIEW',
    };
  }
  if (kod === '20') {
    return {
      suggestedLegalPath: 'smluvni_sluzebnost',
      recommendationCode: 'DOPORUCENO_SOSB',
      suggestedInstrumentType: phase === 'post_survey' ? 'sk_konecna' : 'sosb',
      section104aEligibility: 'NOT_ELIGIBLE',
    };
  }
  if ((BREMENA_CHAROS_KOD_104A_ELIGIBLE as readonly string[]).includes(kod)) {
    return {
      suggestedLegalPath: 'zakonna_104a',
      recommendationCode: 'DOPORUCENO_104A',
      suggestedInstrumentType: 'zakonny_104a',
      section104aEligibility: 'ELIGIBLE',
    };
  }
  return {
    suggestedLegalPath: 'smluvni_sluzebnost',
    recommendationCode: 'DOPORUCENO_SOSB',
    suggestedInstrumentType: phase === 'post_survey' ? 'sk_konecna' : 'sosb',
    section104aEligibility: 'NOT_ELIGIBLE',
  };
}

/**
 * Suggest instrument type for one owner/subject from CharOsKod.
 * Recommendation only — CharOs 3/4/5 yield `zakonny_104a` as *suggestion*, not confirmation.
 * - veřejní (3/4/5) → `zakonny_104a`
 * - soukromí / ostatní → SoSB (pre) or SK konečná (post survey)
 * - never auto-suggests `suz` (manual only)
 * Prefer `suggestBremenaLegalPath` when you need recommendation codes / branch.
 */
export function suggestBremenaInstrumentType(
  charOsKod: string | null | undefined,
  phase: BremenaPrivateContractPhase = 'pre_construction',
): Extract<BremenaInstrumentType, 'zakonny_104a' | 'sosb' | 'sk_konecna'> | null {
  return suggestBremenaLegalPath(charOsKod, phase).suggestedInstrumentType;
}

export function isBremenaCharOsKod104aEligible(charOsKod: string | null | undefined): boolean {
  const kod = (charOsKod ?? '').trim();
  return (BREMENA_CHAROS_KOD_104A_ELIGIBLE as readonly string[]).includes(kod);
}

/**
 * Instruments to create AFTER an authorized person confirms the legal path (P1+).
 * Defaults (pre-construction):
 * - private / smluvni_sluzebnost → SoSB only (no empty sk_konecna)
 * - zakonna_104a → §104a only (no auto SK)
 * - suz_umisteni → SUZ only
 * Post-survey private land may add/switch to SK konečná.
 */
export function resolveBremenaInstrumentsAfterConfirm(
  confirmedLegalPath: string | null | undefined,
  phase: BremenaPrivateContractPhase = 'pre_construction',
): BremenaInstrumentType[] {
  const path = (confirmedLegalPath ?? '').trim();
  if (path === 'zakonna_104a') return ['zakonny_104a'];
  if (path === 'suz_umisteni') return ['suz'];
  if (path === 'smluvni_sluzebnost') {
    return phase === 'post_survey' ? ['sk_konecna'] : ['sosb'];
  }
  return [];
}

/**
 * Fixed companions in the per-owner „3 smlouvy ke stažení“ row.
 * Product / n8n trio = (SoSB|§104a) + SK konečná + SUZ.
 * Download UI only — Import must not auto-create these (P0.2).
 */
export const BREMENA_PARTY_DOWNLOAD_FIXED_TYPES = ['sk_konecna', 'suz'] as const satisfies readonly BremenaInstrumentType[];

export type BremenaPartyDownloadType =
  | Extract<BremenaInstrumentType, 'sosb' | 'zakonny_104a' | 'sk_konecna' | 'suz'>;

/**
 * Three downloadable contract types for one owner row (UI download matrix).
 * Not used by import to create instruments — confirmation gate comes first.
 */
export function resolveBremenaPartyDownloadTypes(
  charOsKod: string | null | undefined,
): readonly [BremenaPartyDownloadType, BremenaPartyDownloadType, BremenaPartyDownloadType] {
  const primary: BremenaPartyDownloadType = isBremenaCharOsKod104aEligible(charOsKod)
    ? 'zakonny_104a'
    : 'sosb';
  return [primary, ...BREMENA_PARTY_DOWNLOAD_FIXED_TYPES];
}

/** Types that E3 can fill to PDF today (committed HTML templates). */
export const BREMENA_E3_GENERATABLE_TYPES = ['sosb', 'sk_konecna', 'suz'] as const satisfies readonly BremenaInstrumentType[];

export function isBremenaE3GeneratableType(value: string | null | undefined): boolean {
  const key = (value ?? '').trim();
  return (BREMENA_E3_GENERATABLE_TYPES as readonly string[]).includes(key);
}

/**
 * Consent subtypes for instrument type `souhlas` (P2 create stubs).
 * `WRITTEN_CONSENT_104` — písemný souhlas v kontextu §104a větve.
 * `OWNER_CONSENT_187` — souhlas vlastníka dle §187 (stub; no HTML generate yet).
 */
export const BREMENA_CONSENT_KINDS = ['WRITTEN_CONSENT_104', 'OWNER_CONSENT_187'] as const;
export type BremenaConsentKind = (typeof BREMENA_CONSENT_KINDS)[number];

export const BREMENA_CONSENT_KIND_LABELS_CS: Record<BremenaConsentKind, string> = {
  WRITTEN_CONSENT_104: 'Písemný souhlas (§ 104)',
  OWNER_CONSENT_187: 'Souhlas vlastníka (§ 187)',
};

export function isBremenaConsentKind(value: string | null | undefined): value is BremenaConsentKind {
  return includesConst(BREMENA_CONSENT_KINDS, value);
}

export function normalizeBremenaConsentKind(
  value: string | null | undefined,
): BremenaConsentKind | null {
  return normalizeConst(BREMENA_CONSENT_KINDS, value);
}

/** Companion `souhlas` stub created with the primary instrument after legal-path confirm. */
export interface BremenaConsentStubAfterConfirm {
  instrumentType: Extract<BremenaInstrumentType, 'souhlas'>;
  consentKind: BremenaConsentKind;
}

/**
 * Consent instrument stubs AFTER an authorized person confirms the legal path (P2).
 * - zakonna_104a → WRITTEN_CONSENT_104 (písemný souhlas alongside §104a)
 * - smluvni_sluzebnost → OWNER_CONSENT_187 (owner consent stub; no PDF yet)
 * - suz_umisteni → none (placement protocol remains SUZ appendix, not a separate step yet)
 */
export function resolveBremenaConsentStubsAfterConfirm(
  confirmedLegalPath: string | null | undefined,
  _phase: BremenaPrivateContractPhase = 'pre_construction',
): BremenaConsentStubAfterConfirm[] {
  const path = (confirmedLegalPath ?? '').trim();
  if (path === 'zakonna_104a') {
    return [{ instrumentType: 'souhlas', consentKind: 'WRITTEN_CONSENT_104' }];
  }
  if (path === 'smluvni_sluzebnost') {
    return [{ instrumentType: 'souhlas', consentKind: 'OWNER_CONSENT_187' }];
  }
  return [];
}

/**
 * Default self-sign limit copied into `BREMENA_DEFAULT_SIGNING_PROFILE`.
 * Names, POA and “bezúplatně ≠ oprávnění podepsat” live on the versioned profile.
 */
export const BREMENA_SELF_SIGN_MAX_CZK = 500_000;
